<template>
  <!-- phone-flush: no telefone o painel vai de borda a borda, com o respiro dele (ver InstanceCard) -->
  <ontos-base v-bind="baseProps" ref="base" phone-flush>
    <!-- O mesmo painel da edição do ambiente (ver EditSystem). Sem nome ainda, o título é a ação -->
    <ontos-form-panel v-if="loaded" :title="$tt('workspace-create')" :save-disabled="isSaving" @save="save">
      <template #controls>
        <ontos-header-action icon="mdi-arrow-left" :label="$tt('back')" :to="{name: 'home'}"/>
      </template>
      <v-form ref="form">
        <ontos-system-input ref="input" :value="system" @input="system = $event" :systems="systems"/>
      </v-form>
    </ontos-form-panel>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import SystemInput from "@/components/design/system/SystemInput.vue";
import {NotUniqueError} from "@/errors/errors";
import RouteComponent from "@/components/shared/RouteComponent";
import {browserTimeZone} from "@/utils/timeZones";
import FormPanel from "@/components/shared/FormPanel.vue";

@Component({components: {'ontos-system-input': SystemInput, 'ontos-form-panel': FormPanel}})
class CreateSystem extends RouteComponent {
  //O fuso já vem com o de quem cria (pedido do usuário): é o caso comum, e muda-se ali mesmo
  system = {title: "", alias: "", timeZone: browserTimeZone()}
  systems = []
  declare $refs: {input: InstanceType<typeof SystemInput>}

  async load() {
    this.systems = await this.$systems.list()
  }

  async save() {
    await this.saving(async () => {
      const input = this.$refs.input;
      try {
        if (input.validateModel()) {
          await this.$systems.add(this.system)
          this.info(this.$tt('info.workspace-created', {name: this.system.title}))
          await this.$router.push({name: 'design-system', params: {system: this.system.alias}})
        }
      } catch (err) {
        if (err instanceof NotUniqueError) {
          input.notUnique(err.data.property as 'title' | 'alias')
        } else this.throwError(this.$tt('error.create-workspace', {name: this.system.title}), err)
      }
    })
  }
}


export default toNative(CreateSystem)
</script>